var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6095 11.2891H1.1314C0.7309 11.2891 0.605743 11.1389 0.605743 10.7635V7.73467C0.605743 7.33417 0.755931 7.20901 1.1314 7.20901H3.6095V5.00626C3.6095 4.00501 3.78472 3.05382 4.28534 2.17772C4.811 1.2766 5.56194 0.675845 6.51313 0.325407C7.13891 0.100125 7.76469 0 8.44054 0H10.8936C11.244 0 11.3942 0.150188 11.3942 0.500626V3.35419C11.3942 3.70463 11.244 3.85482 10.8936 3.85482C10.2178 3.85482 9.54191 3.85482 8.86607 3.87985C8.19022 3.87985 7.83979 4.20526 7.83979 4.90613C7.81475 5.65707 7.83979 6.38298 7.83979 7.15895H10.7434C11.1439 7.15895 11.2941 7.30914 11.2941 7.70964V10.7384C11.2941 11.1389 11.1689 11.2641 10.7434 11.2641H7.83979V19.4243C7.83979 19.8498 7.71463 20 7.26407 20H4.13515C3.75969 20 3.6095 19.8498 3.6095 19.4743V11.2891Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5662226977253e053f3b0ed99895caf6.svg";
export { ForwardRef as ReactComponent };